import {Directive, Input} from '@angular/core';
import {AbstractControl, NG_VALIDATORS, Validator} from '@angular/forms';

export function RepeatChar(repeatLength) {
  return (control: AbstractControl) => {
    const value = control.value ? String(control.value) : '';

    let selectedChar = value[0],
      charCount = 1;
    for (let charAt = 1; charAt < value.length; charAt++) {
      const char = value[charAt];
      if (selectedChar === char) {
        charCount++;
      } else {
        selectedChar = char;
      }

      if (charCount === repeatLength) {
        return {repeat: true};
      }
    }

    return null;
  };
}

@Directive({
  selector: '[repeatChar]',
  providers: [{provide: NG_VALIDATORS, useExisting: RepeatCharDirective, multi: true}],
})
export class RepeatCharDirective implements Validator {
  private repeatLength: number;

  @Input()
  set repeatChar(value: number) {
    this.validate = RepeatChar((this.repeatLength = value));
  }
  get repeatChar() {
    return this.repeatLength;
  }

  validate(control: AbstractControl) {
    return null;
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/validators/repeat-char.validator.ts